module.exports = __webpack_public_path__ + "static/media/tree-decorated.aa165676.svg";